
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12977',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12977",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9857",
  "foundations-components": "static-1.8305",
  "foundations-components-legacy": "static-1.1330",
  "foundations-theming": "static-1.4638",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8223",
  "hub-http-shared-msw-handlers": "static-1.10440",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11674",
  "I18n": "static-7.1649",
  "jasmine-runner": "static-1.6654",
  "marketplace-discovery-studio-lib": "static-1.451",
  "marketplace-storefront-base": "static-1.13040",
  "quartz": "static-1.7293",
  "react-dlb": "static-1.83",
  "react-rhumb": "static-1.16903",
  "reactive-variable-buffer-atom": "static-1.3055",
  "reporting-testing-lib": "static-1.10270",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12719",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7483",
  "ui-addon-i18n": "static-1.11346",
  "ui-addon-react-router-dom": "static-1.9733",
  "unified-auth": "static-1.731",
  "unified-auth-core-lib": "static-1.1013",
  "usage-tracker": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.5",
  "customer-data-property-utils": "static-1.8296",
  "hub-http": "static-1.6417",
  "integrations-lib": "static-1.16777",
  "marketplace-ui-common": "static-1.20402",
  "marketplace-ui-install": "static-1.388",
  "property-management-iframe": "static-1.13820",
  "quartz-config": "static-1.1071",
  "quartz-core": "static-1.6512",
  "quartz-routing": "static-1.723",
  "quick-fetch": "static-1.4057",
  "react": "static-7.189",
  "rpc-client-utils": "static-1.4858",
  "ts-schema": "static-1.4219",
  "ui-universal-auth": "static-1.9217",
  "UIComponents": "static-3.8620",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3538",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3570",
  "quartz-webpack": "static-1.3517",
  "bend-plugin-quartz-routing": "static-1.371",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4574",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5075",
  "foundations-theming-specialty": "static-1.2354",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9625",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.49",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5480",
  "react-virtualized": "static-2.102",
  "StyleGuideUI": "static-3.491",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2328",
  "ui-fonts": "static-1.936",
  "ui-images": "static-2.1211",
  "bend-plugin-foundations-theming": "static-1.3121",
  "foundations-theming-base": "static-1.3623",
  "stylex": "static-1.37",
  "HeadJS": "static-2.780",
  "hs-test-utils-bend-plugin": "static-1.3334",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4523",
  "ui-addon-video-player": "static-1.8906",
  "ai-components-ui-library": "static-1.9459",
  "ai-rendering-library": "static-1.10878",
  "chirp-fetch": "static-1.2087",
  "connections-embed-lib": "static-1.1354",
  "copilot-toolkit": "static-1.11645",
  "feedback-loader": "static-1.29658",
  "laboratory-lib": "static-3.7351",
  "marketplace-embed": "static-1.22687",
  "marketplace-ui-details": "static-1.10297",
  "marketplace-ui-reviews": "static-1.20357",
  "marketplace-ui-tracking": "static-1.14572",
  "sanitize-text": "static-1.8346",
  "usage-tracker-multi": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.5",
  "wootric-nps": "static-1.7121",
  "quartz-head": "static-1.958",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4853",
  "immer": "static-1.33",
  "immerable": "static-1.4347",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2623",
  "reporting-data": "static-1.68337",
  "cssUtils": "static-1.849",
  "flux-actions": "static-1.354",
  "HubStyle": "static-2.11981",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10409",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10564",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.5",
  "icons": "static-2.667",
  "marketplace-ui-apps-core": "static-1.18934",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4707",
  "foundations-components-test-utils": "static-1.5788",
  "quartz-i18n": "static-1.968",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.246",
  "ads-unified-auth-lib": "static-1.763",
  "google-sheets-integration-lib": "static-1.823",
  "microsoft-drive-integration-lib": "static-1.928",
  "surveymonkey-integration-lib": "static-1.268",
  "slack-ui-library": "static-1.10598",
  "fsm": "static-1.3931",
  "customer-data-objects": "static-1.7880",
  "property-translator": "static-1.5594",
  "hs-locale-management": "static-1.220",
  "frontend-preferences-client": "static-1.8126",
  "hs-promise-utils": "static-1.5792",
  "hubspot-apollo-client": "static-1.5077",
  "integrations-error-boundary-lib": "static-1.14192",
  "integrations-tracking-lib": "static-1.5807",
  "native-integrations-shared-strings": "static-1.7978",
  "sanitize": "static-1.4677",
  "superstore": "static-1.4958",
  "ui-shepherd-react": "static-3.10461",
  "ai-settings-ui-library": "static-1.8188",
  "hub-http-janus": "static-1.857",
  "hubspotter-http": "static-1.4790",
  "immutable-less": "static-1.4850",
  "marketplace-ui-client-types": "static-1.17809",
  "nav-meta": "static-1.30218",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18256",
  "ui-product-approvals-common": "static-1.775",
  "ai-studio-lib": "static-1.12222",
  "hubspot-prosemirror": "static-1.18799",
  "integrations-reconnect-lib": "static-1.327",
  "ui-addon-iframeable": "static-1.9275",
  "ui-addon-integrations-directory-panel": "static-2.8222",
  "ui-product-approvals": "static-1.28880",
  "ui-tool-access": "static-1.10353",
  "inbound-db-properties-service-client": "static-1.3984",
  "property-management-common": "static-1.6108",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.554",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.968",
  "quartz-test": "static-1.968",
  "quartz-tracking": "static-1.672",
  "trellis-components": "static-1.2347",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.268",
  "bender-build-tools": "static-1.3321",
  "usage-tracker-anonymous": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-public": "static-1-session-replay-endpoint-migration.5",
  "amplitude-session-replay-browser": "static-1.60",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22313",
  "ContentUtils": "static-1.68942",
  "customer-data-objects-ui-components": "static-1.13231",
  "sassPrefix": "static-1.160",
  "avatar-components": "static-1.2697",
  "breeze-engine-core": "static-1.699",
  "breeze-onboarding-components": "static-1.505",
  "customer-data-filters-ui": "static-1.40556",
  "customer-data-reference-ui-components": "static-1.13376",
  "embedded-academy-lib": "static-1.15081",
  "ExportDialog": "static-6.10579",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41804",
  "reporting-snowflake": "static-1.56955",
  "reporting-ui-components": "static-2.65608",
  "reporting-visualizations": "static-1.60413",
  "trellis-theming": "static-1.1151",
  "ui-addon-teams": "static-1.21799",
  "upgrade-components-lib": "static-1.398",
  "magpie-lib": "static-1.5692",
  "navigation-components": "static-1.18581",
  "breeze-engine-lib": "static-1.1421",
  "magpie-types": "static-1.5152",
  "simple-logging-lib": "static-1.3249",
  "fail-safe": "static-1.146",
  "app-governance-lib": "static-1.2164",
  "developer-experience-shared-components": "static-1.10707",
  "purchase-motions-components": "static-1.6207",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9816",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3901",
  "reference-resolvers": "static-1.8376",
  "ui-extensibility-client-types": "static-1.4123",
  "hubspot-apollo-cache": "static-1.536",
  "universal-page-editor-lib": "static-1.3210",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3339",
  "atom": "static-1.5276",
  "merchandise-lib": "static-1.269",
  "salesImages": "static-1.529",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10839",
  "ui-addon-draggable": "static-3.4956",
  "content-assistance-lib": "static-1.8054",
  "content-media-capture": "static-1.5146",
  "customer-data-ui-utilities": "static-1.10025",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24206",
  "growth-payments-core": "static-1.25959",
  "knowledge-content-types": "static-1.8591",
  "payment-link-components": "static-1.23972",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20168",
  "ui-addon-emoji-picker": "static-1.10085",
  "ui-business-units-lib": "static-1.9280",
  "video-components-external": "static-1.11916",
  "video-data-lib": "static-1.35574",
  "navigation-messaging": "static-1.7908",
  "react-dnd-compat": "static-1.4814",
  "batch-promise": "static-1.1744",
  "crm-component-utils": "static-1.39624",
  "crm-properties-common-lib": "static-1.6087",
  "customer-data-properties": "static-1.52259",
  "external-options-client-types": "static-1.4265",
  "framework-data-schema-resolvers": "static-1.7094",
  "property-value-citations": "static-1.2873",
  "reference-resolvers-lite": "static-1.8296",
  "hubspotter-http-shared-msw-handlers": "static-1.10438",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.33",
  "cms-field-types": "static-1.5015",
  "content-icons-ui": "static-1.2285",
  "onboarding-journeys-lib": "static-1.614",
  "conversations-skeleton-state": "static-1.7447",
  "crm-message-bus": "static-1.43539",
  "customer-data-filters-ui-msw-helpers": "static-1.22991",
  "events-data-lib": "static-1.438",
  "FormUrlGenerator": "static-2.4923",
  "framework-builder-read-service-client": "static-1.4145",
  "framework-data-schema-quick-fetch": "static-1.6999",
  "multi-account-reference-resolvers": "static-1.1182",
  "onboarding-tours": "static-1.16967",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14248",
  "academy-common-lib": "static-1.14541",
  "pulse": "static-1.815",
  "dashboard-lib": "static-1.82318",
  "getting-started-shared-tasks": "static-1.18992",
  "hubspot-prosemirror-plugins": "static-1.18791",
  "share-with-third-party-component-lib": "static-1.8904",
  "ui-asset-management-lib": "static-1.11285",
  "user-context": "static-1.5311",
  "reporting-plugins": "static-1.10647",
  "reporting-reports": "static-1.68015",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.922",
  "nest": "static-1.435",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.97",
  "framework-listing-lib": "static-2.29263",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31163",
  "apps-service-types": "static-1.3973",
  "oauth-service-types": "static-1.4453",
  "onboarding-scopes": "static-1.6658",
  "purchase-motions-api": "static-1.6210",
  "signup-constants": "static-1.19366",
  "signup-ui-url-generator": "static-2.8257",
  "onboarding-tours-client": "static-1.5181",
  "platform-infra-nav-components": "static-1.7812",
  "subscription-experience-data-types": "static-1.15151",
  "crm-record-cards-service-types": "static-1.3723",
  "location-customization-utils-lib": "static-1.9862",
  "redux-thunk": "static-2.43",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29112",
  "content-media-composition-data-lib": "static-1.12950",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4625",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.457",
  "ui-addon-opt": "static-4.8560",
  "commerce-tours-lib": "static-1.6464",
  "growth-onboarding-reliability": "static-1.5282",
  "sales-checkout-service-client": "static-1.3743",
  "data-token-picker": "static-1.16748",
  "FileManagerLib": "static-1.39846",
  "content-media-compositions": "static-2.16957",
  "media-bridge-lib": "static-1.19266",
  "card-properties-lib": "static-1.44793",
  "commerce-subscription-lib": "static-1.37591",
  "crm-actions": "static-1.6549",
  "crm-cards-sdk": "static-1.44209",
  "customer-data-properties-shared-msw-handlers": "static-1.9767",
  "customer-data-tracking": "static-1.7084",
  "hs-resources": "static-1.379",
  "calling-global-api": "static-1.65181",
  "calling-internal-common": "static-1.31514",
  "calling-lifecycle-internal": "static-1.66563",
  "calling-lifecycle-messages": "static-1.58857",
  "commerce-products-lib": "static-1.10275",
  "conditional-properties-service-client": "static-1.3936",
  "crm-links": "static-1.6516",
  "crm-index-visualization-core": "static-1.4399",
  "crm-pipelines-api-client-types": "static-1.4277",
  "formula-editor": "static-1.14602",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4355",
  "meetings-icalendar-utils-lib": "static-1.831",
  "multi-currency-client-types": "static-1.3830",
  "object-builder-ui-client": "static-1.49392",
  "pipeline-validation-client-types": "static-1.4105",
  "smart-property-lib": "static-1.8089",
  "tiered-pricing": "static-1.1767",
  "topics-actions-lib": "static-1.354",
  "ui-addon-form-validation": "static-1.11189",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.213",
  "restore-request-side-panel-lib": "static-1.1402",
  "growth-data-modal": "static-1.5749",
  "growth-onboarding-confetti": "static-1.3261",
  "growth-onboarding-next-action-utils": "static-1.2492",
  "onboarding-tours-utils": "static-1.1033",
  "ui-shepherd-tracker": "static-1.7842",
  "academy-service-client": "static-1.3887",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39705",
  "SafeStorage": "static-1.4605",
  "video-embed": "static-1.36408",
  "bend-plugin-pulse": "static-1.318",
  "event-emitter": "static-1.1150",
  "fast-json-patch": "static-1.66",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24824",
  "viral-links-lib": "static-1.7270",
  "nested-table": "static-1.437",
  "timezone-utils": "static-2.5444",
  "getting-started-shared-tasks-store": "static-1.18110",
  "campaign-roi-lib": "static-1.9823",
  "ui-addon-calendars": "static-2.5523",
  "customer-data-views-management": "static-1.25846",
  "framework-data-table": "static-2.12357",
  "marketing-platform-lib": "static-1.7067",
  "nudge-client-utils": "static-1.2989",
  "nudge-custom-ui-functions": "static-1.1352",
  "switchboard-lib": "static-1.420",
  "app-users-service-client": "static-1.5818",
  "app-users-service-types": "static-1.5226",
  "mini-checkout-client": "static-1.27338",
  "onboarding-utils": "static-1.5561",
  "permissions-shared-i18n-strings-fe": "static-1.2094",
  "ui-coaching-tips-shared-config": "static-1.29097",
  "edison-service-client-types": "static-1.586",
  "growth-onboarding-feedback-components": "static-1.6780",
  "audio-components": "static-1.6206",
  "FileManagerImages": "static-1.37357",
  "video-components": "static-1.13918",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92602",
  "customer-data-sidebar": "static-2.46549",
  "enrichment-properties-lib": "static-1.17499",
  "ui-addon-draggable-compat": "static-2.4458",
  "universal-record-utils-lib": "static-1.1535",
  "commerce-billing-lib": "static-1.19762",
  "commerce-shared-components-lib": "static-1.19028",
  "commerce-tools-ui-lib": "static-1.10870",
  "crm-fe-perf": "static-1.23101",
  "calling-error-reporting": "static-1.31521",
  "shared-worker-versioning": "static-1.11237",
  "calling-usage-tracker": "static-1.6740",
  "voice-sms-access-library": "static-1.1716",
  "commerce-permissions": "static-1.976",
  "products-iframe-lib": "static-1.8400",
  "products-ui-components-shared-msw-handlers": "static-1.10822",
  "crm-index-associations-lib": "static-1.6641",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10523",
  "sales-views-client-types": "static-1.4457",
  "bark-lib": "static-1.16694",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.504",
  "policy-lib": "static-1.6987",
  "react-tinymce": "static-1.55769",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10586",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54895",
  "tinymce-plugins": "static-1.58009",
  "tinymce-themes": "static-1.56865",
  "onboarding-data-sync-lib": "static-1.2310",
  "growth-onboarding-next-action-components": "static-1.2520",
  "user-context-client": "static-1.4751",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4732",
  "outpost": "static-1.4366",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22016",
  "sales-email-signature-service-client": "static-1.4043",
  "ts-utils-lib": "static-1.374",
  "crm-export-dialog": "static-1.6484",
  "crm-view-components": "static-1.878",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7532",
  "nudge-custom-function-registry": "static-1.2746",
  "nudge-renderer-utils": "static-1.3065",
  "whisper-core-api": "static-1.7113",
  "InboxConnectUtils": "static-4.15351",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.6049",
  "settings-content-modals": "static-1.46642",
  "social-insights-client-types": "static-1.22589",
  "crm_universal": "static-1.22355",
  "customer-data-email": "static-1.18386",
  "card-payment-highlight-lib": "static-1.37762",
  "card-subscription-highlight-lib": "static-1.40014",
  "commerce-contract-lib": "static-1.12964",
  "invoices-highlight-card-lib": "static-1.55386",
  "orders-highlight-card-lib": "static-1.22003",
  "products-highlight-card-lib": "static-1.18558",
  "quotes-highlight-card-lib": "static-1.72632",
  "crm-source-interpretation-lib": "static-1.5533",
  "crm-object-search-query-utilities": "static-1.10016",
  "utility-belt": "static-1.2731",
  "payments-enrollment-embed-lib": "static-1.23588",
  "stripe-embedded-components": "static-1.7854",
  "customer-data-rte": "static-1.33475",
  "cv-backend-services": "static-1.1589",
  "growth-onboarding-empty-states": "static-1.6115",
  "payments-post-enroll-local-storage-lib": "static-1.5304",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38722",
  "calling-orchestration-schema": "static-1.36493",
  "react-reducer-toolkit": "static-1.16147",
  "hub-http-contrib": "static-1.3241",
  "interframe": "static-3.4955",
  "tinymce-data": "static-1.40980",
  "ui-addon-sales-email": "static-1.5412",
  "layout-dnd-components": "static-1.12819",
  "layout-dnd-utils": "static-1.11794",
  "ui-brand-identity-lib": "static-1.16011",
  "NamespacedHubStyle": "static-2.9189",
  "meetings-connect-utils-lib": "static-1.7805",
  "checkout-sdk": "static-3.24181",
  "company-details-components": "static-1.6397",
  "payment-method-components": "static-1.7048",
  "pricing-pages-ui-components": "static-1.15094",
  "quote-checkout-service-types": "static-1.3652",
  "upgrade-catalog-service-types": "static-1.3694",
  "access-control-lib": "static-1.10638",
  "EmailComponents": "static-1.55350",
  "EmailData": "static-1.54028",
  "redux-less": "static-2.9680",
  "sequences-lib": "static-1.8383",
  "ui-gdpr-components": "static-1.10550",
  "products-ui-components": "static-1.40793",
  "accounting-integrations-ui-components": "static-1.7394",
  "invoices-ui-lib": "static-1.55402",
  "commerce-products-api": "static-1.2581",
  "invoices-iframe-lib": "static-1.57460",
  "quotes-modal-lib": "static-1.103310",
  "quotes-ui-lib": "static-1.81353",
  "stripe-connect-js": "static-1.73",
  "draft-content-plugins": "static-1.28741",
  "ContentData": "static-1.69017",
  "layout-data-lib": "static-1.10119",
  "hub-http-rxjs": "static-1.822",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4136",
  "billing-payments-client-types": "static-1.4188",
  "react-performance-metrics-lib": "static-1.756",
  "pricing-pages-api": "static-1.14959",
  "ContentComponents": "static-2.71898",
  "marketing-contacts-lib": "static-1.10748",
  "marketing-email-service-types": "static-1.2043",
  "messaging-editing-lib": "static-1.46922",
  "messaging-usage-based-billing-components-lib": "static-1.1784",
  "automation-ui-source-apps": "static-1.19460",
  "automation-ui-types": "static-1.20378",
  "messaging-types-lib": "static-1.46659",
  "onboarding-settings-client": "static-1.4706",
  "sequences-client-types-lib": "static-1.8240",
  "commerce-tax-lib": "static-1.737",
  "price-books-api": "static-1.1503",
  "price-books-components": "static-1.1561",
  "property-description-translator": "static-1.4038",
  "ramp-editor": "static-1.701",
  "commerce-analytics-service-client": "static-1.3731",
  "totals-ui-components": "static-1.24115",
  "SalesContentIndexUI": "static-3.9514",
  "advanced-menus-core": "static-1.15447",
  "advanced-menus-lib": "static-1.12341",
  "ui-memberships-settings-lib": "static-1.34600",
  "segments-query-core": "static-1.1621",
  "trials-service-types": "static-1.4084",
  "automation-ui-ubb": "static-1.6294",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7537",
  "data-token-views": "static-1.16729",
  "forms-utils-lib": "static-1.12940",
  "payments-embed-points-lib": "static-1.13431",
  "simple-menus-core": "static-1.15446",
  "simple-menus-lib": "static-1.16963",
  "videoconference-integration-components": "static-1.7110",
  "marketing-contacts-client": "static-1.7709",
  "mc-hard-limits-client-types": "static-1.101",
  "automation-applications-service-types": "static-1.3629",
  "automation-platform-service-types": "static-1.2639",
  "ContentEditorUI": "static-2.77678",
  "short-messages-app-service-client": "static-1.4118",
  "web-interactives-components": "static-1.14099",
  "web-interactives-data": "static-1.14100",
  "messaging-shared-utils-lib": "static-1.1233",
  "messaging-user-info-utils-lib": "static-1.1403",
  "email-portal-health-service-types": "static-1.1177",
  "line-items-api": "static-1.978",
  "commerce-totals-service-types": "static-1.3954",
  "FireAlarmUi": "static-1.4647",
  "sales-templates-service-types-lib": "static-1.4307",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22314",
  "automation-ui-usage-tracking": "static-1.21777",
  "data-studio-ubb": "static-1.3292",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27473",
  "collaboration-sidebar": "static-1.58482",
  "content-management-data-lib": "static-1.5790",
  "copilot-plugins": "static-1.11617",
  "cta-picker": "static-1.36900",
  "customer-agent-discovery-components-lib": "static-1.3648",
  "editor-components": "static-1.13518",
  "editor-iframe-lib": "static-1.8672",
  "error-messaging-js": "static-1.5395",
  "FormsCommonComponents": "static-1.86378",
  "pictos": "static-7.188",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10846",
  "SharedLegalStrings": "static-1.1944",
  "smart-content-core": "static-1.42980",
  "smart-content-lib": "static-1.43633",
  "social-composer-lib": "static-1.59887",
  "structured-content-lib": "static-1.25721",
  "theme-previewer-lib": "static-1.53750",
  "tinymce-copilot": "static-1.16963",
  "xray-recommendation-lib": "static-1.8152",
  "automation-ui-routing": "static-1.21735",
  "sql-reporting-client-types": "static-1.5806",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42618",
  "campaigns-utils-lib": "static-1.3394",
  "reporting-enablement": "static-1.23577",
  "chatspot-widget-iframe": "static-1.22304",
  "collaboration-sidebar-common": "static-1.3279",
  "forms-ai-lib": "static-1.4620",
  "codemirror-dlb": "static-1.59237",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6635",
  "report-customization-components": "static-1.13684",
  "data-quality-ui-library": "static-1.13557",
  "reporting-filters": "static-1.813",
  "reporting-insights-lib": "static-1.2343"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12977",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9857",
  "foundations-components": "/foundations-components/static-1.8305",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1330",
  "foundations-theming": "/foundations-theming/static-1.4638",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8223",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10440",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11674",
  "I18n": "/I18n/static-7.1649",
  "jasmine-runner": "/jasmine-runner/static-1.6654",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.451",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13040",
  "quartz": "/quartz/static-1.7293",
  "react-dlb": "/react-dlb/static-1.83",
  "react-rhumb": "/react-rhumb/static-1.16903",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3055",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10270",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12719",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7483",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11346",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9733",
  "unified-auth": "/unified-auth/static-1.731",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1013",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.5",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8296",
  "hub-http": "/hub-http/static-1.6417",
  "integrations-lib": "/integrations-lib/static-1.16777",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20402",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.388",
  "property-management-iframe": "/property-management-iframe/static-1.13820",
  "quartz-config": "/quartz-config/static-1.1071",
  "quartz-core": "/quartz-core/static-1.6512",
  "quartz-routing": "/quartz-routing/static-1.723",
  "quick-fetch": "/quick-fetch/static-1.4057",
  "react": "/react/static-7.189",
  "rpc-client-utils": "/rpc-client-utils/static-1.4858",
  "ts-schema": "/ts-schema/static-1.4219",
  "ui-universal-auth": "/ui-universal-auth/static-1.9217",
  "UIComponents": "/UIComponents/static-3.8620",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3538",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3570",
  "quartz-webpack": "/quartz-webpack/static-1.3517",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.371",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4574",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5075",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2354",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9625",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.49",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5480",
  "react-virtualized": "/react-virtualized/static-2.102",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2328",
  "ui-fonts": "/ui-fonts/static-1.936",
  "ui-images": "/ui-images/static-2.1211",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3121",
  "foundations-theming-base": "/foundations-theming-base/static-1.3623",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.780",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3334",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4523",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8906",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9459",
  "ai-rendering-library": "/ai-rendering-library/static-1.10878",
  "chirp-fetch": "/chirp-fetch/static-1.2087",
  "connections-embed-lib": "/connections-embed-lib/static-1.1354",
  "copilot-toolkit": "/copilot-toolkit/static-1.11645",
  "feedback-loader": "/feedback-loader/static-1.29658",
  "laboratory-lib": "/laboratory-lib/static-3.7351",
  "marketplace-embed": "/marketplace-embed/static-1.22687",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10297",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20357",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14572",
  "sanitize-text": "/sanitize-text/static-1.8346",
  "usage-tracker-multi": "/usage-tracker-multi/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.5",
  "wootric-nps": "/wootric-nps/static-1.7121",
  "quartz-head": "/quartz-head/static-1.958",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4853",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4347",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2623",
  "reporting-data": "/reporting-data/static-1.68337",
  "cssUtils": "/cssUtils/static-1.849",
  "flux-actions": "/flux-actions/static-1.354",
  "HubStyle": "/HubStyle/static-2.11981",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10409",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10564",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.5",
  "icons": "/icons/static-2.667",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18934",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4707",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5788",
  "quartz-i18n": "/quartz-i18n/static-1.968",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.246",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.763",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.823",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.928",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.268",
  "slack-ui-library": "/slack-ui-library/static-1.10598",
  "fsm": "/fsm/static-1.3931",
  "customer-data-objects": "/customer-data-objects/static-1.7880",
  "property-translator": "/property-translator/static-1.5594",
  "hs-locale-management": "/hs-locale-management/static-1.220",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8126",
  "hs-promise-utils": "/hs-promise-utils/static-1.5792",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5077",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14192",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5807",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7978",
  "sanitize": "/sanitize/static-1.4677",
  "superstore": "/superstore/static-1.4958",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10461",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8188",
  "hub-http-janus": "/hub-http-janus/static-1.857",
  "hubspotter-http": "/hubspotter-http/static-1.4790",
  "immutable-less": "/immutable-less/static-1.4850",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17809",
  "nav-meta": "/nav-meta/static-1.30218",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18256",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.775",
  "ai-studio-lib": "/ai-studio-lib/static-1.12222",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18799",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.327",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9275",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8222",
  "ui-product-approvals": "/ui-product-approvals/static-1.28880",
  "ui-tool-access": "/ui-tool-access/static-1.10353",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3984",
  "property-management-common": "/property-management-common/static-1.6108",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.554",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.968",
  "quartz-test": "/quartz-test/static-1.968",
  "quartz-tracking": "/quartz-tracking/static-1.672",
  "trellis-components": "/trellis-components/static-1.2347",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.268",
  "bender-build-tools": "/bender-build-tools/static-1.3321",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-public": "/usage-tracker-public/static-1-session-replay-endpoint-migration.5",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22313",
  "ContentUtils": "/ContentUtils/static-1.68942",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13231",
  "sassPrefix": "/sassPrefix/static-1.160",
  "avatar-components": "/avatar-components/static-1.2697",
  "breeze-engine-core": "/breeze-engine-core/static-1.699",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.505",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40556",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13376",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15081",
  "ExportDialog": "/ExportDialog/static-6.10579",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41804",
  "reporting-snowflake": "/reporting-snowflake/static-1.56955",
  "reporting-ui-components": "/reporting-ui-components/static-2.65608",
  "reporting-visualizations": "/reporting-visualizations/static-1.60413",
  "trellis-theming": "/trellis-theming/static-1.1151",
  "ui-addon-teams": "/ui-addon-teams/static-1.21799",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.398",
  "magpie-lib": "/magpie-lib/static-1.5692",
  "navigation-components": "/navigation-components/static-1.18581",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1421",
  "magpie-types": "/magpie-types/static-1.5152",
  "simple-logging-lib": "/simple-logging-lib/static-1.3249",
  "fail-safe": "/fail-safe/static-1.146",
  "app-governance-lib": "/app-governance-lib/static-1.2164",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10707",
  "purchase-motions-components": "/purchase-motions-components/static-1.6207",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9816",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3901",
  "reference-resolvers": "/reference-resolvers/static-1.8376",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4123",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.536",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3210",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3339",
  "atom": "/atom/static-1.5276",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "salesImages": "/salesImages/static-1.529",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10839",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4956",
  "content-assistance-lib": "/content-assistance-lib/static-1.8054",
  "content-media-capture": "/content-media-capture/static-1.5146",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10025",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24206",
  "growth-payments-core": "/growth-payments-core/static-1.25959",
  "knowledge-content-types": "/knowledge-content-types/static-1.8591",
  "payment-link-components": "/payment-link-components/static-1.23972",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20168",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10085",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9280",
  "video-components-external": "/video-components-external/static-1.11916",
  "video-data-lib": "/video-data-lib/static-1.35574",
  "navigation-messaging": "/navigation-messaging/static-1.7908",
  "react-dnd-compat": "/react-dnd-compat/static-1.4814",
  "batch-promise": "/batch-promise/static-1.1744",
  "crm-component-utils": "/crm-component-utils/static-1.39624",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6087",
  "customer-data-properties": "/customer-data-properties/static-1.52259",
  "external-options-client-types": "/external-options-client-types/static-1.4265",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7094",
  "property-value-citations": "/property-value-citations/static-1.2873",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8296",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10438",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "cms-field-types": "/cms-field-types/static-1.5015",
  "content-icons-ui": "/content-icons-ui/static-1.2285",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.614",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7447",
  "crm-message-bus": "/crm-message-bus/static-1.43539",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22991",
  "events-data-lib": "/events-data-lib/static-1.438",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4923",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4145",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6999",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1182",
  "onboarding-tours": "/onboarding-tours/static-1.16967",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14248",
  "academy-common-lib": "/academy-common-lib/static-1.14541",
  "pulse": "/pulse/static-1.815",
  "dashboard-lib": "/dashboard-lib/static-1.82318",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18992",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18791",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8904",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11285",
  "user-context": "/user-context/static-1.5311",
  "reporting-plugins": "/reporting-plugins/static-1.10647",
  "reporting-reports": "/reporting-reports/static-1.68015",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.922",
  "nest": "/nest/static-1.435",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.97",
  "framework-listing-lib": "/framework-listing-lib/static-2.29263",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31163",
  "apps-service-types": "/apps-service-types/static-1.3973",
  "oauth-service-types": "/oauth-service-types/static-1.4453",
  "onboarding-scopes": "/onboarding-scopes/static-1.6658",
  "purchase-motions-api": "/purchase-motions-api/static-1.6210",
  "signup-constants": "/signup-constants/static-1.19366",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8257",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5181",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7812",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15151",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3723",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9862",
  "redux-thunk": "/redux-thunk/static-2.43",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29112",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12950",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4625",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.457",
  "ui-addon-opt": "/ui-addon-opt/static-4.8560",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6464",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5282",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "data-token-picker": "/data-token-picker/static-1.16748",
  "FileManagerLib": "/FileManagerLib/static-1.39846",
  "content-media-compositions": "/content-media-compositions/static-2.16957",
  "media-bridge-lib": "/media-bridge-lib/static-1.19266",
  "card-properties-lib": "/card-properties-lib/static-1.44793",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37591",
  "crm-actions": "/crm-actions/static-1.6549",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44209",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9767",
  "customer-data-tracking": "/customer-data-tracking/static-1.7084",
  "hs-resources": "/hs-resources/static-1.379",
  "calling-global-api": "/calling-global-api/static-1.65181",
  "calling-internal-common": "/calling-internal-common/static-1.31514",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66563",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58857",
  "commerce-products-lib": "/commerce-products-lib/static-1.10275",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3936",
  "crm-links": "/crm-links/static-1.6516",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4399",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4277",
  "formula-editor": "/formula-editor/static-1.14602",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4355",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.831",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3830",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49392",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4105",
  "smart-property-lib": "/smart-property-lib/static-1.8089",
  "tiered-pricing": "/tiered-pricing/static-1.1767",
  "topics-actions-lib": "/topics-actions-lib/static-1.354",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11189",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.213",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1402",
  "growth-data-modal": "/growth-data-modal/static-1.5749",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3261",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2492",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1033",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7842",
  "academy-service-client": "/academy-service-client/static-1.3887",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39705",
  "SafeStorage": "/SafeStorage/static-1.4605",
  "video-embed": "/video-embed/static-1.36408",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.318",
  "event-emitter": "/event-emitter/static-1.1150",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24824",
  "viral-links-lib": "/viral-links-lib/static-1.7270",
  "nested-table": "/nested-table/static-1.437",
  "timezone-utils": "/timezone-utils/static-2.5444",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18110",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9823",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5523",
  "customer-data-views-management": "/customer-data-views-management/static-1.25846",
  "framework-data-table": "/framework-data-table/static-2.12357",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7067",
  "nudge-client-utils": "/nudge-client-utils/static-1.2989",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1352",
  "switchboard-lib": "/switchboard-lib/static-1.420",
  "app-users-service-client": "/app-users-service-client/static-1.5818",
  "app-users-service-types": "/app-users-service-types/static-1.5226",
  "mini-checkout-client": "/mini-checkout-client/static-1.27338",
  "onboarding-utils": "/onboarding-utils/static-1.5561",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2094",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29097",
  "edison-service-client-types": "/edison-service-client-types/static-1.586",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6780",
  "audio-components": "/audio-components/static-1.6206",
  "FileManagerImages": "/FileManagerImages/static-1.37357",
  "video-components": "/video-components/static-1.13918",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92602",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46549",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17499",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4458",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1535",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19762",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19028",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10870",
  "crm-fe-perf": "/crm-fe-perf/static-1.23101",
  "calling-error-reporting": "/calling-error-reporting/static-1.31521",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11237",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6740",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1716",
  "commerce-permissions": "/commerce-permissions/static-1.976",
  "products-iframe-lib": "/products-iframe-lib/static-1.8400",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10822",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6641",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10523",
  "sales-views-client-types": "/sales-views-client-types/static-1.4457",
  "bark-lib": "/bark-lib/static-1.16694",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.504",
  "policy-lib": "/policy-lib/static-1.6987",
  "react-tinymce": "/react-tinymce/static-1.55769",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10586",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54895",
  "tinymce-plugins": "/tinymce-plugins/static-1.58009",
  "tinymce-themes": "/tinymce-themes/static-1.56865",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2310",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2520",
  "user-context-client": "/user-context-client/static-1.4751",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4732",
  "outpost": "/outpost/static-1.4366",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22016",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4043",
  "ts-utils-lib": "/ts-utils-lib/static-1.374",
  "crm-export-dialog": "/crm-export-dialog/static-1.6484",
  "crm-view-components": "/crm-view-components/static-1.878",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7532",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2746",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3065",
  "whisper-core-api": "/whisper-core-api/static-1.7113",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15351",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.6049",
  "settings-content-modals": "/settings-content-modals/static-1.46642",
  "social-insights-client-types": "/social-insights-client-types/static-1.22589",
  "crm_universal": "/crm_universal/static-1.22355",
  "customer-data-email": "/customer-data-email/static-1.18386",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37762",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40014",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12964",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55386",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22003",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18558",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72632",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5533",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10016",
  "utility-belt": "/utility-belt/static-1.2731",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23588",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7854",
  "customer-data-rte": "/customer-data-rte/static-1.33475",
  "cv-backend-services": "/cv-backend-services/static-1.1589",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6115",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5304",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38722",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36493",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16147",
  "hub-http-contrib": "/hub-http-contrib/static-1.3241",
  "interframe": "/interframe/static-3.4955",
  "tinymce-data": "/tinymce-data/static-1.40980",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5412",
  "layout-dnd-components": "/layout-dnd-components/static-1.12819",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11794",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16011",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9189",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7805",
  "checkout-sdk": "/checkout-sdk/static-3.24181",
  "company-details-components": "/company-details-components/static-1.6397",
  "payment-method-components": "/payment-method-components/static-1.7048",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15094",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3652",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3694",
  "access-control-lib": "/access-control-lib/static-1.10638",
  "EmailComponents": "/EmailComponents/static-1.55350",
  "EmailData": "/EmailData/static-1.54028",
  "redux-less": "/redux-less/static-2.9680",
  "sequences-lib": "/sequences-lib/static-1.8383",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10550",
  "products-ui-components": "/products-ui-components/static-1.40793",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7394",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55402",
  "commerce-products-api": "/commerce-products-api/static-1.2581",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57460",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103310",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81353",
  "stripe-connect-js": "/stripe-connect-js/static-1.73",
  "draft-content-plugins": "/draft-content-plugins/static-1.28741",
  "ContentData": "/ContentData/static-1.69017",
  "layout-data-lib": "/layout-data-lib/static-1.10119",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.822",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4136",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4188",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.756",
  "pricing-pages-api": "/pricing-pages-api/static-1.14959",
  "ContentComponents": "/ContentComponents/static-2.71898",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10748",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2043",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46922",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1784",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19460",
  "automation-ui-types": "/automation-ui-types/static-1.20378",
  "messaging-types-lib": "/messaging-types-lib/static-1.46659",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4706",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8240",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.737",
  "price-books-api": "/price-books-api/static-1.1503",
  "price-books-components": "/price-books-components/static-1.1561",
  "property-description-translator": "/property-description-translator/static-1.4038",
  "ramp-editor": "/ramp-editor/static-1.701",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3731",
  "totals-ui-components": "/totals-ui-components/static-1.24115",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9514",
  "advanced-menus-core": "/advanced-menus-core/static-1.15447",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12341",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34600",
  "segments-query-core": "/segments-query-core/static-1.1621",
  "trials-service-types": "/trials-service-types/static-1.4084",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6294",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7537",
  "data-token-views": "/data-token-views/static-1.16729",
  "forms-utils-lib": "/forms-utils-lib/static-1.12940",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13431",
  "simple-menus-core": "/simple-menus-core/static-1.15446",
  "simple-menus-lib": "/simple-menus-lib/static-1.16963",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7110",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7709",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.101",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3629",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2639",
  "ContentEditorUI": "/ContentEditorUI/static-2.77678",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4118",
  "web-interactives-components": "/web-interactives-components/static-1.14099",
  "web-interactives-data": "/web-interactives-data/static-1.14100",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1233",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1403",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1177",
  "line-items-api": "/line-items-api/static-1.978",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3954",
  "FireAlarmUi": "/FireAlarmUi/static-1.4647",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4307",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22314",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21777",
  "data-studio-ubb": "/data-studio-ubb/static-1.3292",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27473",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58482",
  "content-management-data-lib": "/content-management-data-lib/static-1.5790",
  "copilot-plugins": "/copilot-plugins/static-1.11617",
  "cta-picker": "/cta-picker/static-1.36900",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3648",
  "editor-components": "/editor-components/static-1.13518",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8672",
  "error-messaging-js": "/error-messaging-js/static-1.5395",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86378",
  "pictos": "/pictos/static-7.188",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10846",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1944",
  "smart-content-core": "/smart-content-core/static-1.42980",
  "smart-content-lib": "/smart-content-lib/static-1.43633",
  "social-composer-lib": "/social-composer-lib/static-1.59887",
  "structured-content-lib": "/structured-content-lib/static-1.25721",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53750",
  "tinymce-copilot": "/tinymce-copilot/static-1.16963",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8152",
  "automation-ui-routing": "/automation-ui-routing/static-1.21735",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5806",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42618",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3394",
  "reporting-enablement": "/reporting-enablement/static-1.23577",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22304",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3279",
  "forms-ai-lib": "/forms-ai-lib/static-1.4620",
  "codemirror-dlb": "/codemirror-dlb/static-1.59237",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6635",
  "report-customization-components": "/report-customization-components/static-1.13684",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13557",
  "reporting-filters": "/reporting-filters/static-1.813",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2343"
}
};
